import React from 'react'
import { connect } from 'react-redux'
import Button from '../components/Button.jsx'

const FooterBtnContainer = props => (
    <div className="footer-btn-container">
        <Button
            type="footer"
            text={props.langData.btnText}
            link={props.link}
            onClick={props.onClick}
        />
    </div>
)

FooterBtnContainer.defaultProps = {
    link: '/kontakt',
    onClick: null
}

const mapStateToProps = state => ({
    langData: state.langData.footer
})

export default connect(mapStateToProps)(FooterBtnContainer)



// WEBPACK FOOTER //
// ./src/scripts/containers/FooterBtnContainer.jsx